// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"6f0454f9917353f2fd39","293":"ed7b4dfa7db33f826c51","518":"74ed7e45698563130a77","779":"04decf44c3a250e2b461"}[chunkId] + ".js";
};